/* Discount pop-up: opens once, `data-delay` seconds into a visit
   (counted across pages). Closing it
   keeps it away for `data-days` days; signing up keeps it away for good.
   The form is posted the ordinary way (so it passes Shopify's bot check);
   when the page comes back the card reopens on the thank-you or the error. */
(function () {
  var pop = document.querySelector('[data-o2pop2]');
  if (!pop) return;
  var KEY = 'o2pop2', SENT = 'o2pop2-sent';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function sent(v) { try { if (v === undefined) return sessionStorage.getItem(SENT) === '1'; if (v) sessionStorage.setItem(SENT, '1'); else sessionStorage.removeItem(SENT); } catch (e) { return false; } }

  // the photograph waits (lazy) until a few seconds before the card opens
  function warm() { var im = pop.querySelector('.o2pop2__media img'); if (im) im.loading = 'eager'; }
  var editor = pop.hasAttribute('data-editor');
  var preview = pop.hasAttribute('data-preview');
  var state = read();
  var days = +pop.dataset.days || 14;
  var lastFocus = null;

  function open() {
    if (!pop.hidden) return;
    lastFocus = document.activeElement;
    warm();
    pop.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
    var input = pop.querySelector('input[type="email"]');
    if (input && window.matchMedia('(pointer: fine)').matches) setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
    document.documentElement.classList.add('o2pop2-lock');
    document.addEventListener('keydown', onKey);
  }
  function close() {
    pop.classList.remove('is-open');
    setTimeout(function () { pop.hidden = true; }, 450);
    document.documentElement.classList.remove('o2pop2-lock');
    document.removeEventListener('keydown', onKey);
    if (!editor) { var s = read(); if (!s.joined) { s.closed = Date.now(); write(s); } }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  pop.querySelectorAll('[data-o2pop2-close]').forEach(function (b) { b.addEventListener('click', close); });

  // phones: once the keyboard is up, bring the field and the button into view
  var input = pop.querySelector('input[type="email"]');
  if (input) input.addEventListener('focus', function () {
    setTimeout(function () { (pop.querySelector('.o2pop2__btn') || input).scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 350);
  });

  // back from our own post: Shopify marks the form done, or with its errors
  var mark = pop.querySelector('[data-o2pop2-state]');
  var ours = sent(); sent(false);
  if (ours && mark && mark.dataset.o2pop2State === 'done' || ours && /customer_posted=true/.test(location.search)) {
    state.joined = Date.now(); write(state);
    pop.querySelector('[data-o2pop2-ask]').hidden = true;
    pop.querySelector('[data-o2pop2-done]').hidden = false;
    open();
    setTimeout(close, 7000);
    return;
  }
  if (ours && mark && mark.dataset.o2pop2State === 'error') {
    var err = pop.querySelector('[data-o2pop2-error]'); if (err) err.hidden = false;
    open();
    return;
  }

  // in the theme editor it only opens when "Open it in the theme editor" is on
  if (editor) {
    if (preview) open();
  } else {
    var recentlyClosed = state.closed && (Date.now() - state.closed) < days * 864e5;
    if (!state.joined && !recentlyClosed && !/customer_posted=true/.test(location.search)) {
      // the delay counts time on the site, not on this page: moving to
      // another page carries on the countdown instead of starting it again
      var delay = (+pop.dataset.delay || 15) * 1000, t0 = Date.now();
      try { t0 = +sessionStorage.getItem('o2pop2-t0') || t0; sessionStorage.setItem('o2pop2-t0', t0); } catch (e) {}
      var left = Math.max(1500, delay - (Date.now() - t0));
      setTimeout(warm, Math.max(0, left - 3000));
      setTimeout(open, left);
    }
  }

  var form = pop.querySelector('[data-o2pop2-form]');
  if (form) form.addEventListener('submit', function () {
    sent(true);
    var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
  });
})();
